import { render } from "./subViewLoadingView.vue?vue&type=template&id=077afb55&scoped=true&ts=true"
import script from "./subViewLoadingView.vue?vue&type=script&lang=ts"
export * from "./subViewLoadingView.vue?vue&type=script&lang=ts"

import "./subViewLoadingView.vue?vue&type=style&index=0&id=077afb55&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077afb55"]])

export default __exports__